export default function HeaderConsentLogo() {
  return (
    <div
      aria-label="IMGA"
      data-testid="header-consent-logo"
      role="img"
      className="flex h-[29px] w-[71px] items-center justify-center"
    >
      <img
        src="/icons/imga-header-logo.svg"
        alt=""
        aria-hidden="true"
        className="block h-[29px] w-auto"
      />
    </div>
  );
}
